import React, { FunctionComponent } from 'react'
import { FieldRenderProps } from '@progress/kendo-react-form';
import { DropDownList, DropDownListChangeEvent, MultiSelect } from '@progress/kendo-react-dropdowns';
import { ClientApi } from '../../../redux/api/ClientApi';
import { UserApi } from '../../../redux/api/UserApi';

export const EndUserField: FunctionComponent<FieldRenderProps> = props => {
    const { field, ...others } = props;
    const defClientId = field.ConfigSettings?.DefaultCompany;
    const { data: clients } = ClientApi.useGetClientListQuery(null);
    const defClient = clients?.filter(c => c.ID === defClientId)
    const { data: users, isFetching: usersLoading } = UserApi.useGetUsersQuery({ companyId: defClient?.length ? defClient[0].ID : null })
    const currentValues = field?.VALUES?.length > 0 ? users?.filter(i => field?.VALUES.map(v => parseInt(v)).indexOf(i.ID) > -1) : null;
    //const [selectedClient, setSelectedClient] = React.useState<IClient>(defClient?.length ? defClient[0] : null)
    const fieldChanged = (e) => {
        //console.log('fieldChanged',e);
        let fieldChange = { ...field, VALUES: [e.value.ID] }
        props.onChange({ value: fieldChange });
    }
    const clientChanged = (e: DropDownListChangeEvent) => {
        let fieldChange = { ...field, ConfigSettings: { ...field.ConfigSettings, DefaultCompany: e.value.ID } }
        props.onChange({ value: fieldChange });

        console.log('clientChanged', fieldChange)
    }
    const multiFieldChanged = (e) => {
        let fieldChange = { ...field, VALUES: e.value.map(v => v.ID) }
        props.onChange({ value: fieldChange });
    }
    const clientList = (
        <>
            <DropDownList {...others} valid={true} popupSettings={{ className: "z500" }} defaultItem={{ Company_Name: "Select" }} onChange={clientChanged} value={defClient?.length > 0 ? defClient[0] : undefined} data={clients} dataItemKey="ID" textField="Company_Name" />
        </>
    )

    if (field.ConfigSettings?.Display === "0") {
        //Dropdown
        return (
            <div>
                {clientList}
                <DropDownList  {...others} loading={usersLoading} popupSettings={{ className: "z500" }} value={currentValues?.length ? currentValues[0] : null} onChange={fieldChanged} defaultItem={{ Value: "Select" }} data={users} textField="FullName" dataItemKey='ID' />
            </div>)
    }
    else if (field.ConfigSettings?.Display === "1") {
        //Multi select
        return (
            <div>
                {clientList}
                <MultiSelect {...others} loading={usersLoading} popupSettings={{ className: "z500" }} value={currentValues} onChange={multiFieldChanged} data={users} textField="FullName" dataItemKey='ID' />
            </div>
        )
    }

}
